export function getParentDomain(domain: string, strict = true): string {
  if (domain.indexOf('.') === -1) {
    if (strict) {
      throw new Error(`Cannot find a parent domain in ${domain}`);
    }
    return '';
  }
  return domain.split('.').slice(1).join('.');
}
